import { Button } from '../ui/button';
import { InteractSearchIcon } from '@/client/assets';
import { useModelStore } from '@/client/store/model-store';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useMedia from 'react-use/lib/useMedia';

export const SearchButton = () => {
  const { t } = useTranslation();
  const isDesktop = useMedia('(min-width: 768px)');
  const searchOpen = useModelStore(state => state.searchOpen);
  const setSearchOpen = useModelStore(state => state.setSearchOpen);
  useEffect(() => {
    const handle = (e: KeyboardEvent) => {
      if (['k', 'K'].includes(e.key) && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setSearchOpen(!searchOpen);
      }
    };
    document.addEventListener('keydown', handle);
    return () => document.removeEventListener('keydown', handle);
  }, [searchOpen, setSearchOpen]);
  if (!isDesktop) return null;
  return (
    <Button
      type="button"
      variant="outline"
      onClick={() => setSearchOpen(true)}
      className="w-full h-10 flex bg-transparent hover:bg-card items-center shadow-none justify-between border border-foreground/4  rounded-full font-medium cursor-pointer px-4 text-foreground/70"
    >
      <InteractSearchIcon className="size-4 fill-current" />
      <span className="flex-1 text-start text-sm">{t('search')}</span>
      <kbd className="pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border border-foreground/4 px-1.5 text-[10px] font-medium text-foreground/70">
        <span className="text-xs">⌘</span>K
      </kbd>
    </Button>
  );
};
